import { render, staticRenderFns } from "./api_test.vue?vue&type=template&id=2c0a3679&scoped=true&"
import script from "./api_test.vue?vue&type=script&lang=js&"
export * from "./api_test.vue?vue&type=script&lang=js&"
import style0 from "./api_test.vue?vue&type=style&index=0&id=2c0a3679&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a3679",
  null
  
)

export default component.exports